import { useEffect, useState } from "react";
import DocumentiFieraTable from "./DocumentiFieraTable";
import { Card, Icon } from "@mui/material";
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CaricaFile from "./CaricaFile";
import UtilityService from "services/API/utility/UtilityService";
import base64ToArrayBuffer from "common/script/base64ToArrayBuffer";
import MDTypography from "common/components/MD/MDTypography";
import SpazioComponent from "./SpazioComponent";
import { MobileFriendly } from "@mui/icons-material";
import MDBox from "common/components/MD/MDBox";
import SpazioComponentMini from "./SpazioComponentMini";


function ServizioFieraComponent({ richiesta, filtra, servizio }) {

    const [lista_moduli, setLista_moduli] = useState([]);
    useEffect(() => {

        setLista_moduli(richiesta.moduli_servizi);
    }, []);

    async function download_pdf_modello() {

        UtilityService.downloadModulo(servizio.idFile)
            .then(response => {

                return response.data;
            })
            .then(blob => {

                var arrrayBuffer = base64ToArrayBuffer(blob); //data is the base64 encoded string
                var blobb = new Blob([arrrayBuffer], { type: "application/pdf" });
                var url = URL.createObjectURL(blobb);
                var a = document.createElement('a');
                a.href = url;
                a.target = "_blank";

                a.download = servizio.nome_file;
                ;

                document.body.appendChild(a); // append the element to the dom
                a.click();
                a.remove(); // afterwards, remove the element  
            })
            .catch(error => {
                console.error(error);
            });




    }


    const righe = [];
    const icona = (<Icon fontSize="small" color="success" ml={15}>drawicon</Icon>);


    lista_moduli.forEach((modulo) => {

        if (modulo.id_modello == servizio.idFile && modulo.id_modulo && modulo.id_modulo !== 0) {
            righe.push({

                icona: icona,
                modulo: modulo,
                idRichiesta: richiesta.idRichiesta,
                nome_modulo: modulo.nome_modulo,
                nome_modello: modulo.modello.nome_modulo,
                modello: modulo.modello,
                modulo_da_compilare: (<MDTypography variant="button" fontWeight="regular" color="text"
                    sx={{ cursor: "pointer", userSelect: "none", ml: -1 }}
                    onClick={() => download_pdf_modello()}
                >{servizio.nome_file}
                </MDTypography>),
                modulo_compilato: (<CaricaFile id_richiesta={richiesta.idRichiesta} modulo={modulo} filtra={filtra} />),
                protocollato: (modulo.protocollato ? <CheckCircleIcon color="success" /> : "No"),

            })
        }
    }










    )

    righe.push({

        idRichiesta: richiesta.idRichiesta,
        nome_modulo: '',
        nome_modello: servizio.nome_modulo,
        modello: servizio,
        modulo_da_compilare: (<MDTypography variant="button" fontWeight="regular" color="text"
            sx={{ cursor: "pointer", userSelect: "none", ml: -1 }}
            onClick={() => download_pdf_modello()}
        >{servizio.nome_file}
        </MDTypography>),
        modulo_compilato: (<CaricaFile id_richiesta={richiesta.idRichiesta} modulo={{ id_modulo: 0, id_modello: servizio.idFile, nome_modello: servizio.nome_modulo, modello: servizio, }} filtra={filtra} />),
        protocollato: ("No"),

    })


    const ppTableData = {
        rows: righe,

        columns: [


            { Header: "Modulo", accessor: "nome_modello", width: "20%", align: "left", id: "servizi_0" },
            { Header: "Scarica il Modulo da Compilare", accessor: "modulo_da_compilare", align: "left", with: "15%", id: "servizi_1" },
            { Header: "Ricarica il Modulo Compilato", accessor: "modulo_compilato", align: "left", id: "servizi_2" },
            { Header: "Validato", accessor: "protocollato", align: "left", width: "10%", id: "servizi_3" },
        ],



    };

    const mypagination = { color: 'success', variant: "contained" };

    return (
        <MDBox>

            <MDBox mx={10}>
                <MDBox mb={2} ><MDTypography color='success'>Tipologia Espositiva : {richiesta.tipologia_concessa},{richiesta.mq_concessi}mq</MDTypography></MDBox>




            </MDBox>
            <MDBox mx={10}>
                <MDBox mb={2} ></MDBox>
                <DocumentiFieraTable
                    canSearch={false}
                    table={ppTableData}
                    nome_tabella="servizi"
                    isSorted={false}
                    entriesPerPage={false}
                    showTotalEntries={false}
                    noEndBorder
                    responsive={true}
                    filtro_server={false}
                    canExport={false}
                    canSend={false}
                    enableColumnFilters={false}
                    pagination={mypagination}

                />
            </MDBox>
        </MDBox>
    );

}
export default ServizioFieraComponent;
